import React, { useContext, useEffect, useState } from "react";
import PaymentList from "./PaymentList";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import axios from "axios";
import { checkFilterItem, fetchFilterData } from "../../../utils/fetchFilterData";
import InvoiceDialog from "../../elements/invoiceDialog/InvoiceDialog";
import Notification from "../../elements/notification/Notification";
import { AppContext } from "../../../App";
import ItemsPerPageSelect from "../../elements/filter/ItemsPerPageSelect";
import TransactionFilter from "../../elements/transactions/TransactionFilter";
import FilterAppliedList from "../../elements/filter/FilterAppliedList";
import TransactionExportButton from "../../elements/transactions/transactionExportButton";
import { useTranslation } from "react-i18next";

import MaterialPagination from "../../styles/materialPagination";
import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledPaymentWrapper } from "../styledPayment";
import { parseAxiosError } from "../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";
import { itemsPerPageValue } from "../../../utils/ItemsPerPageValue";

const PaymentContainer = () => {
  const { t } = useTranslation("paymentsPage");
  const [payments, setPayments] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);

  const { user } = useContext(AppContext);

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "createdAt[gte]": checkFilterItem(history, "createdAt[gte]", null, true),
    "createdAt[lte]": checkFilterItem(history, "createdAt[lte]", null, true),
    "status.value": checkFilterItem(history, "status.value", null),
    "id": checkFilterItem(history, "id", null),
    "referenceId": checkFilterItem(history, "referenceId", null),
    "processingId": checkFilterItem(history, "processingId", null),
    "exchangeId": checkFilterItem(history, "exchangeId", null),
    "hash": checkFilterItem(history, "hash", null),
    "note": checkFilterItem(history, "note", null),
    "resourceType": checkFilterItem(history, "resourceType", null),
    "processedAmount[gte]": checkFilterItem(history, "processedAmount[gte]", null, true),
    "processedAmount[lte]": checkFilterItem(history, "processedAmount[lte]", null, true),
    "currency.asset": checkFilterItem(history, "currency.asset", null),
    "paymentSystem.name": checkFilterItem(history, "paymentSystem.name", null),
    "connection.service.name": checkFilterItem(history, "connection.service.name", null),
    "connection.project.name": checkFilterItem(history, "connection.project.name", null),
    "paymentType": checkFilterItem(history, "paymentType", null),
    "transactionType": checkFilterItem(history, "transactionType", null),
    "relatedReferenceId": checkFilterItem(history, "relatedReferenceId", null)
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchPayments = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/get-transaction-native" + filterUrl + '&resourceType=payment', userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setPayments(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  //TODO add pusher
  const updateTransaction = (message) => {
    if(!message?.data) {
      return;
    }

    const data = JSON.parse(message.data);
    const index = payments.findIndex(p => p.id === data.id);
    if (index >= 0) {
      payments[index].processedAmount = data.processedAmount;
      payments[index].status = data.status;
      let newArr = [];
      setPayments([
        ...payments,
        ...newArr
      ]);
    }
  };

  useEffect(() => {
    fetchPayments();
  }, [filterData]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{t("meta.title")}</title>
        </Helmet>
        <StyledPaymentWrapper>
          <div className="payments-head">
            <div className="payments-head__left">
              <TransactionFilter
                filterData={filterData}
                setFilterData={setFilterData}
                direction="payments"
              />
              <TransactionExportButton
                direction="payments"
                filterData={filterData}
              />
              <ItemsPerPageSelect
                itemsPerPage={filterData.itemsPerPage}
                setItemsPerPage={(data) => setFilterData({
                  ...filterData,
                  "itemsPerPage": data,
                  page: 1
                })}
              />
            </div>
            <InvoiceDialog
              direction="payments"
              fetchTransactionList={fetchPayments}
            />
          </div>
          <FilterAppliedList
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <PaymentList payments={payments} />
          {totalPageCount > 1  &&
            <MaterialPagination
              count={totalPageCount}
              shape="rounded"
              page={filterData.page}
              onChange={(event, page) => onChangePage(event, page)}
            />}
        </StyledPaymentWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default PaymentContainer;